// L'app Reps sur l'App Store : tout part d'ici.
//
// UNE SEULE source pour toute la plateforme : NEXT_PUBLIC_REPS_APPSTORE_URL,
// dans les deux blocs de next.config.mjs. Elle décide de la carte du rail
// /reps (badge + QR), des mentions de l'app sur /pricing et du bouton de la
// page d'atterrissage binôme. Le jour de la mise en ligne, la renseigner
// suffit : il n'y a rien d'autre à toucher, ici ou ailleurs.
//
// Le préfixe NEXT_PUBLIC_ n'est pas décoratif : PricingComponent est un
// composant client et appelle isRepsAppStoreLive(). Sans lui, le navigateur
// lirait undefined là où le serveur lit l'URL, et la page se désaccorderait à
// l'hydratation.
//
// Vide = l'app n'est pas publiée : la carte ne se rend pas du tout et le rail
// redevient exactement ce qu'il était (clés + boosters, réservés aux comptes).
//
// Format attendu (guidelines Apple) : domaine apps.apple.com (itunes.apple.com
// est déprécié, appstore.com est réservé aux supports hors ligne), et storefront
// volontairement OMIS pour que chaque visiteur atterrisse dans la boutique de
// son pays :
//     https://apps.apple.com/app/id0000000000
// Pour mesurer ce que le rail rapporte dans App Store Connect, ajouter le
// couple pt/ct (les deux sont nécessaires, le suivi démarre 24h après) :
//     https://apps.apple.com/app/id0000000000?pt=<provider>&ct=reps-rail&mt=8
//
export const REPS_APP_STORE_URL =
    process.env.NEXT_PUBLIC_REPS_APPSTORE_URL || null;

/** L'app est-elle publiée ? Décide de l'affichage de la carte ET du rail. */
export function isRepsAppStoreLive() {
    return (
        typeof REPS_APP_STORE_URL === "string" &&
        REPS_APP_STORE_URL.trim() !== ""
    );
}

/**
 * Bannière App Store de Safari (« Smart App Banner ») : la balise
 * <meta name="apple-itunes-app"> que Safari iOS transforme en bandeau
 * « Ouvrir » / « Télécharger » en haut de la page, avec la note et l'icône
 * de l'app. À étaler dans le `generateMetadata` des pages Reps seulement
 * (rail, parcours, leçon, atterrissages) : le reste du site n'est pas l'app,
 * et un bandeau sur une page de formation parlerait d'autre chose.
 *
 * Vide tant que l'app n'est pas publiée, comme le badge et la carte du rail.
 * L'identifiant Apple est extrait de l'URL (`…/app/id6790285757`) : une seule
 * source, la même variable, rien à recopier ailleurs.
 */
export function repsSmartAppBanner() {
    const id = isRepsAppStoreLive()
        ? REPS_APP_STORE_URL.match(/\/id(\d+)/)?.[1]
        : null;
    return id ? { itunes: { appId: id } } : {};
}

// Badges officiels Apple (App Store Marketing Tools), un par langue et par
// thème. Apple interdit de recolorer son artwork : en sombre on sert la
// variante blanche officielle plutôt qu'un filtre CSS. Le modificateur est
// traduit par Apple, jamais par nous, et "App Store" reste toujours en anglais.
// Les largeurs diffèrent d'une langue à l'autre (le texte FR est plus long) :
// chaque variante porte donc ses propres dimensions, sinon le badge se déforme.
const BADGES = {
    fr: {
        black: "/images/site/assets/app-store/badge-fr-black.svg",
        white: "/images/site/assets/app-store/badge-fr-white.svg",
        width: 127,
        height: 40,
    },
    en: {
        black: "/images/site/assets/app-store/badge-en-black.svg",
        white: "/images/site/assets/app-store/badge-en-white.svg",
        width: 120,
        height: 40,
    },
};

/** Badge officiel de la langue demandée (repli sur le français). */
export function appStoreBadge(locale) {
    return BADGES[locale] || BADGES.fr;
}
